// extracted by mini-css-extract-plugin
export default {"tabs":"settings_tabs__0a3hq"};